module.exports = __webpack_public_path__ + "img/verf-blauw.92d8c355.jpeg";